module.exports = __webpack_public_path__ + "img/icon-word.d3856a76.svg";